(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    function bindCartQty(root) {
      root.querySelectorAll('.js-cart-qty').forEach(function (wrap) {
        var input = wrap.querySelector('.lande-cart__qty-input');
        if (!input) return;

        wrap.querySelectorAll('.js-cart-qty-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var step = parseInt(input.step, 10) || 1;
            var min = parseInt(input.min, 10);
            if (isNaN(min)) min = 0;
            var val = parseInt(input.value, 10) || min;

            if (btn.dataset.dir === 'minus') {
              val = Math.max(min, val - step);
            } else {
              val = val + step;
            }

            input.value = val;
          });
        });
      });
    }

    function init() {
      document.querySelectorAll('.lande-cart').forEach(bindCartQty);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function refreshHeaderCartCount() {
      if (typeof window.mpRefreshHeaderCartCount === 'function') {
        window.mpRefreshHeaderCartCount();
        return;
      }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
          document.querySelectorAll('.lande-header__cart').forEach(function (cartLink) {
            var badge = cartLink.querySelector('.lande-header__cart-count');
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'lande-header__cart-count';
                cartLink.appendChild(badge);
              }
              badge.textContent = String(count);
            } else if (badge) {
              badge.remove();
            }
          });
        })
        .catch(function () {});
    }

    function bindCollectionSort(root) {
      var sortSelect = root.querySelector('.lande-collection__sort-select');
      if (!sortSelect) return;
      sortSelect.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sortSelect.value);
        window.location.href = u.toString();
      });
    }

    function getActiveMpCatValues(filterForm) {
      var values = [];
      if (!filterForm) return values;

      filterForm.querySelectorAll('.js-mp-cat-checkbox:checked').forEach(function (cb) {
        var value = String(cb.value || cb.getAttribute('data-mp-cat-id') || '').trim().toLowerCase();
        if (value) values.push(value);
      });
      return values;
    }

    function mpCatStorageKey() {
      return 'mp_cat:' + window.location.pathname;
    }

    function applyMpCatClientFilter(root) {
      var filterForm = root.querySelector('.lande-collection__filters-form');
      if (!filterForm || !filterForm.querySelector('.js-mp-cat-combined')) return;

      var activeGroups = getActiveMpCatValues(filterForm);
      var cards = root.querySelectorAll('.lande-collection-card[data-mp-product-group]');
      var visibleCount = 0;

      cards.forEach(function (card) {
        var group = String(card.getAttribute('data-mp-product-group') || '').trim().toLowerCase();
        var show = activeGroups.length === 0;

        if (!show) {
          for (var i = 0; i < activeGroups.length; i++) {
            if (group === activeGroups[i]) {
              show = true;
              break;
            }
          }
        }

        card.hidden = !show;
        if (show) visibleCount++;
      });

      var emptyMsg = root.querySelector('.js-mp-cat-empty');
      if (emptyMsg) {
        emptyMsg.hidden = activeGroups.length === 0 || visibleCount > 0;
      }
    }

    function syncMpCatFromUrl(filterForm) {
      var url = new URL(window.location.href);
      var mpCat = url.searchParams.get('mp_cat');
      if (!mpCat) {
        try {
          mpCat = sessionStorage.getItem(mpCatStorageKey());
        } catch (error) {
          mpCat = '';
        }
      }
      if (!filterForm || !mpCat) return;

      var activeIds = mpCat.split(',').map(function (value) {
        return value.trim().toLowerCase();
      }).filter(Boolean);

      filterForm.querySelectorAll('.js-mp-cat-checkbox').forEach(function (cb) {
        var checkboxValue = String(cb.value || cb.getAttribute('data-mp-cat-id') || '').trim().toLowerCase();
        cb.checked = activeIds.indexOf(checkboxValue) !== -1;
      });
      syncMpCatCombined(filterForm);
    }

    function updateMpCatInUrl(filterForm) {
      syncMpCatCombined(filterForm);
      var combined = filterForm.querySelector('.js-mp-cat-combined');
      var url = new URL(window.location.href);

      if (combined && combined.value) {
        url.searchParams.set('mp_cat', combined.value);
        try {
          sessionStorage.setItem(mpCatStorageKey(), combined.value);
        } catch (error) {}
      } else {
        url.searchParams.delete('mp_cat');
        try {
          sessionStorage.removeItem(mpCatStorageKey());
        } catch (error) {}
      }

      window.history.replaceState({}, '', url.toString());
    }

    function syncMpCatCombined(filterForm) {
      var combined = filterForm.querySelector('.js-mp-cat-combined');
      if (!combined) return;

      var values = [];
      filterForm.querySelectorAll('.js-mp-cat-checkbox:checked').forEach(function (cb) {
        values.push(cb.value);
      });
      combined.value = values.join(',');
    }

    function applyCollectionFilters(filterForm) {
      syncMpCatCombined(filterForm);

      var sortHidden = filterForm.querySelector('input[name="sort_by"]');
      var sortSelect = filterForm.closest('.lande-collection--catalog')
        ? filterForm.closest('.lande-collection--catalog').querySelector('.lande-collection__sort-select')
        : null;
      if (sortHidden && sortSelect && sortSelect.value) {
        sortHidden.value = sortSelect.value;
      }

      filterForm.querySelectorAll('.js-price-input-min, .js-price-input-max').forEach(function (input) {
        input.disabled = !input.value || String(input.value).trim() === '';
      });

      var params = new URLSearchParams(new FormData(filterForm));
      if (!params.get('mp_cat')) {
        params.delete('mp_cat');
      }

      var query = params.toString();
      var target = filterForm.getAttribute('action') || window.location.pathname;
      window.location.href = query ? target + '?' + query : target;
    }

    function bindCollectionFilters(root) {
      var filterForm = root.querySelector('.lande-collection__filters-form');
      var panel = root.querySelector('.lande-collection__filters-panel');
      var toggle = root.querySelector('.js-filters-toggle');

      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var open = panel.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      if (!filterForm) return;

      syncMpCatFromUrl(filterForm);
      applyMpCatClientFilter(root);

      filterForm.addEventListener('submit', function (event) {
        event.preventDefault();
        applyCollectionFilters(filterForm);
      });

      filterForm.querySelectorAll('.lande-collection__checkbox').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          if (checkbox.classList.contains('js-mp-cat-checkbox')) {
            updateMpCatInUrl(filterForm);
            applyMpCatClientFilter(root);
            return;
          }
          applyCollectionFilters(filterForm);
        });
      });

      bindPriceFilter(root);
    }

    function bindPriceFilter(root) {
      var block = root.querySelector('.js-price-filter');
      if (!block) return;

      var rangeMaxCents = parseInt(String(block.getAttribute('data-range-max-cents') || '0'), 10);
      if (isNaN(rangeMaxCents) || rangeMaxCents < 1) return;

      var moneyFormat = block.getAttribute('data-money-format') || '{{amount}} dh';
      var minRange = block.querySelector('.js-price-range-min');
      var maxRange = block.querySelector('.js-price-range-max');
      var minInput = block.querySelector('.js-price-input-min');
      var maxInput = block.querySelector('.js-price-input-max');
      var hint = block.querySelector('.js-price-hint');
      var fill = block.querySelector('.js-price-slider-fill');

      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return (cents / 100).toFixed(2) + ' dh';
      }

      function centsToDecimal(cents) {
        return (cents / 100).toFixed(2);
      }

      function decimalToCents(value) {
        var parsed = parseFloat(String(value).replace(',', '.'));
        if (isNaN(parsed) || parsed < 0) parsed = 0;
        return Math.round(parsed * 100);
      }

      function clampRanges() {
        var minC = parseInt(String(minRange.value), 10);
        var maxC = parseInt(String(maxRange.value), 10);
        if (isNaN(minC) || minC < 0) minC = 0;
        if (isNaN(maxC) || maxC < 0) maxC = 0;
        if (minC > maxC) {
          if (document.activeElement === minRange) {
            maxC = minC;
            maxRange.value = String(maxC);
          } else {
            minC = maxC;
            minRange.value = String(minC);
          }
        }
        return { minC: minC, maxC: maxC };
      }

      function updateFromRanges() {
        var values = clampRanges();
        minInput.value = centsToDecimal(values.minC);
        maxInput.value = centsToDecimal(values.maxC);
        if (fill) {
          fill.style.left = ((values.minC / rangeMaxCents) * 100) + '%';
          fill.style.width = (((values.maxC - values.minC) / rangeMaxCents) * 100) + '%';
        }
        if (hint) {
          hint.textContent = formatMoney(values.minC) + ' — ' + formatMoney(values.maxC);
        }
      }

      function updateFromInputs() {
        var minC = decimalToCents(minInput.value);
        var maxC = decimalToCents(maxInput.value);
        if (minC > maxC) {
          if (document.activeElement === minInput) {
            maxC = minC;
            maxInput.value = centsToDecimal(maxC);
          } else {
            minC = maxC;
            minInput.value = centsToDecimal(minC);
          }
        }
        minRange.value = String(Math.min(minC, rangeMaxCents));
        maxRange.value = String(Math.min(maxC, rangeMaxCents));
        updateFromRanges();
      }

      minRange.addEventListener('input', updateFromRanges);
      maxRange.addEventListener('input', updateFromRanges);
      minInput.addEventListener('change', updateFromInputs);
      maxInput.addEventListener('change', updateFromInputs);
      updateFromRanges();
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.lande-collection-card__form');
      if (!form) return;
      e.preventDefault();

      var submitBtn = form.querySelector('button[type="submit"]');
      var previousDisabled = submitBtn ? submitBtn.disabled : false;
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          refreshHeaderCartCount();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = previousDisabled;
        });
    });

    function init() {
      document.querySelectorAll('.lande-collection--catalog').forEach(function (root) {
        bindCollectionSort(root);
        bindCollectionFilters(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lande-accessories-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupCarouselMotion = (scope = document) => {
      const carousels = scope.querySelectorAll('.lande-acc-carousel')
      if (!carousels.length) return

      carousels.forEach((carousel) => {
        if (carousel.dataset.motionInit == 'true') return
        carousel.dataset.motionInit = 'true'

        let rafId = null
        let direction = 1
        let paused = false
        const speed = 2.0

        const step = () => {
          if (!paused) {
            const maxScroll = carousel.scrollWidth - carousel.clientWidth
            if (maxScroll > 0) {
              carousel.scrollLeft += speed * direction
              if (carousel.scrollLeft >= maxScroll - 1) direction = -1
              if (carousel.scrollLeft <= 1) direction = 1
            } else {
              direction = 1
              carousel.scrollLeft = 0
            }
          }

          rafId = window.requestAnimationFrame(step)
        }

        const start = () => {
          if (!rafId) rafId = window.requestAnimationFrame(step)
        }

        const stop = () => {
          if (!rafId) return
          window.cancelAnimationFrame(rafId)
          rafId = null
        }

        carousel.addEventListener('mouseenter', () => {
          paused = true
        })
        carousel.addEventListener('mouseleave', () => {
          paused = false
        })
        carousel.addEventListener('touchstart', () => {
          paused = true
        }, { passive: true })
        carousel.addEventListener('touchend', () => {
          paused = false
        }, { passive: true })

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) stop()
          else start()
        })

        start()
      })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupCarouselMotion(document))
    } else {
      setupCarouselMotion(document)
    }

    document.addEventListener('shopify:section:load', (event) => {
      setupCarouselMotion(event.target)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lande-marque-single-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const carousel = document.querySelector('.brand-carousel');
    if (!carousel) return;

    let speed = 1.5; 
    let direction = 1;
    let isHovered = false;

    carousel.addEventListener('mouseenter', () => isHovered = true);
    carousel.addEventListener('mouseleave', () => isHovered = false);
    carousel.addEventListener('touchstart', () => isHovered = true, { passive: true });
    carousel.addEventListener('touchend', () => setTimeout(() => isHovered = false, 1000), { passive: true });

    function autoScroll() {
      if (!isHovered) {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        if (maxScroll > 0) {
          carousel.scrollLeft += (speed * direction);
          if (carousel.scrollLeft >= maxScroll - 1) direction = -1;
          else if (carousel.scrollLeft <= 1) direction = 1;
        }
      }
      requestAnimationFrame(autoScroll);
    }
    requestAnimationFrame(autoScroll);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lande-production"] && !Shopify.designMode) return;
  try {
    
  /* AUTO SCROLLING JAVASCRIPT L-GALLERY L-TA7T */
  document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('.prod-gallery');
    if (!gallery) return;

    let speed = 1.2;
    let direction = 1;
    let isHovered = false;

    gallery.addEventListener('mouseenter', () => isHovered = true);
    gallery.addEventListener('mouseleave', () => isHovered = false);
    
    gallery.addEventListener('touchstart', () => isHovered = true, { passive: true });
    gallery.addEventListener('touchend', () => setTimeout(() => isHovered = false, 1000), { passive: true });

    function autoScroll() {
      if (!isHovered) {
        const maxScroll = gallery.scrollWidth - gallery.clientWidth;
        if (maxScroll > 0) {
          gallery.scrollLeft += (speed * direction);
          
          if (gallery.scrollLeft >= maxScroll - 1) {
            direction = -1;
          } else if (gallery.scrollLeft <= 1) {
            direction = 1;
          }
        }
      }
      requestAnimationFrame(autoScroll);
    }
    
    requestAnimationFrame(autoScroll);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lande-video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlider(hero) {
      if (!hero || hero.dataset.heroSliderInit === 'true') return;
      hero.dataset.heroSliderInit = 'true';

      const slides = Array.from(hero.querySelectorAll('.lande-video-hero__slide'));
      const dots = Array.from(hero.querySelectorAll('.lande-video-hero__dot'));
      if (slides.length < 2) return;

      const duration = Math.max(3, parseInt(hero.dataset.autoplay, 10) || 6) * 1000;
      let current = 0;
      let dotTimer = null;

      function syncDots(index) {
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        hero.classList.add('lande-video-hero--paused');
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
        });
        syncDots(current);
      }

      function startDotSync() {
        if (dotTimer) window.clearInterval(dotTimer);
        if (hero.classList.contains('lande-video-hero--paused')) return;

        dotTimer = window.setInterval(() => {
          current = (current + 1) % slides.length;
          syncDots(current);
        }, duration);
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.slideDot, 10);
          if (Number.isNaN(index)) return;
          goTo(index);
        });
      });

      hero.addEventListener('mouseleave', () => {
        hero.classList.remove('lande-video-hero--paused');
        slides.forEach((slide) => slide.classList.remove('is-active'));
        current = 0;
        syncDots(0);
        startDotSync();
      });

      syncDots(0);
      startDotSync();
    }

    function initAllHeroSliders() {
      document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllHeroSliders);
    } else {
      initAllHeroSliders();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const hero = event.target.querySelector('[data-hero-slider]');
      if (hero) initHeroSlider(hero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lande_header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function refreshHeaderCartCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
          document.querySelectorAll('.lande-header__cart').forEach(function (cartLink) {
            var badge = cartLink.querySelector('.lande-header__cart-count');
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'lande-header__cart-count';
                cartLink.appendChild(badge);
              }
              badge.textContent = String(count);
              cartLink.classList.add('lande-header__cart--updated');
              window.setTimeout(function () {
                cartLink.classList.remove('lande-header__cart--updated');
              }, 500);
            } else if (badge) {
              badge.remove();
            }
          });
        })
        .catch(function () {});
    }

    window.mpRefreshHeaderCartCount = refreshHeaderCartCount;

    document.querySelectorAll('.lande-header__drawer-backdrop').forEach(function (el) {
      el.addEventListener('click', function () {
        var details = el.closest('details');
        if (details) details.removeAttribute('open');
      });
    });

    function closeLandeSearch(group, toggle) {
      group.classList.remove('lande-header__search-group--open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    document.querySelectorAll('[data-lande-search-group]').forEach(function (group) {
      var toggle = group.querySelector('.lande-header__search-toggle');
      var form = group.querySelector('.lande-header__search');
      var input = form ? form.querySelector('input[type="search"]') : null;
      if (!toggle || !form) return;

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !group.classList.contains('lande-header__search-group--open');
        if (willOpen) {
          group.classList.add('lande-header__search-group--open');
          toggle.setAttribute('aria-expanded', 'true');
          if (input) {
            window.requestAnimationFrame(function () {
              input.focus();
            });
          }
        } else {
          closeLandeSearch(group, toggle);
        }
      });

      document.addEventListener('click', function (e) {
        if (!group.classList.contains('lande-header__search-group--open')) return;
        if (!group.contains(e.target)) closeLandeSearch(group, toggle);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!group.classList.contains('lande-header__search-group--open')) return;
        closeLandeSearch(group, toggle);
        toggle.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-amenities-catalog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var quoteItem = e.target.closest('.mp-catalog__item--quote');
    if (quoteItem) {
      document.querySelectorAll('.mp-catalog__item.is-active').forEach(function (el) {
        if (el !== quoteItem) el.classList.remove('is-active');
      });
      quoteItem.classList.add('is-active');
      return;
    }

    var card = e.target.closest('.mp-catalog__card[data-mp-card-url]');
    if (!card) return;
    if (e.target.closest('a, button')) return;
    var url = card.getAttribute('data-mp-card-url');
    if (url) window.location.assign(url);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-cafes-thes-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function refreshHeaderCartCount() {
      if (typeof window.mpRefreshHeaderCartCount === 'function') {
        window.mpRefreshHeaderCartCount();
        return;
      }
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
          document.querySelectorAll('.lande-header__cart').forEach(function (cartLink) {
            var badge = cartLink.querySelector('.lande-header__cart-count');
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'lande-header__cart-count';
                cartLink.appendChild(badge);
              }
              badge.textContent = String(count);
            } else if (badge) {
              badge.remove();
            }
          });
        })
        .catch(function () {});
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.mp-cafes-thes-page__card-form');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () { refreshHeaderCartCount(); })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-cafes-thes-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function refreshHeaderCartCount() {
      if (typeof window.mpRefreshHeaderCartCount === 'function') {
        window.mpRefreshHeaderCartCount();
        return;
      }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
          document.querySelectorAll('.lande-header__cart').forEach(function (cartLink) {
            var badge = cartLink.querySelector('.lande-header__cart-count');
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'lande-header__cart-count';
                cartLink.appendChild(badge);
              }
              badge.textContent = String(count);
            } else if (badge) {
              badge.remove();
            }
          });
        })
        .catch(function () {});
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.lande-collection-card__form');
      if (!form) return;
      e.preventDefault();

      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          refreshHeaderCartCount();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-linge-hotel-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.mp-cafes-thes-page__card-form');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          if (typeof window.mpRefreshHeaderCartCount === 'function') {
            window.mpRefreshHeaderCartCount();
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function formatMoney(cents, format) {
      var c = parseInt(String(cents || 0), 10);
      if (isNaN(c)) c = 0;
      var out;
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        out = window.Shopify.formatMoney(c, format || '$1');
      } else {
        out = (c / 100).toFixed(2);
      }
      if (c % 100 === 0) {
        out = String(out).replace(/([,.])00(?!\d)/g, '');
      }
      return out;
    }

    function getPdpQty(root) {
      var qtyInput = root.querySelector('.lande-pdp__form input[name="quantity"]');
      var qty = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);
      var qtyMin = parseInt(qtyInput && qtyInput.getAttribute('min') ? qtyInput.getAttribute('min') : '1', 10);
      if (isNaN(qtyMin) || qtyMin < 1) qtyMin = 1;
      if (isNaN(qty) || qty < qtyMin) qty = qtyMin;
      return qty;
    }

    function volumeUnitPrice(baseCents, qty, priceWrap) {
      var carton = parseInt(String(priceWrap.getAttribute('data-volume-carton') || '0'), 10);
      var mid = parseInt(String(priceWrap.getAttribute('data-volume-mid') || '0'), 10);
      var high = parseInt(String(priceWrap.getAttribute('data-volume-high') || '0'), 10);
      if (isNaN(carton) || carton <= 0) return baseCents;
      if (isNaN(mid) || mid < 0) mid = 0;
      if (isNaN(high) || high < 0) high = 0;
      var cartons = Math.floor(qty / carton);
      var unit = baseCents;
      if (cartons >= 10) unit = baseCents - high;
      else if (cartons >= 5) unit = baseCents - mid;
      return unit < 0 ? 0 : unit;
    }

    function updateDisplayedPrice(root) {
      if (!root) return;
      var priceWrap = root.querySelector('[data-lande-pdp-price]');
      if (!priceWrap) return;

      var moneyFormat = root.getAttribute('data-money-format') || '$1';
      var qty = getPdpQty(root);
      var mode = priceWrap.getAttribute('data-price-mode') || 'standard';
      var unitPrice = parseInt(String(priceWrap.getAttribute('data-unit-price') || '0'), 10);
      var unitCompare = parseInt(String(priceWrap.getAttribute('data-unit-compare') || '0'), 10);
      if (isNaN(unitPrice) || unitPrice < 0) unitPrice = 0;
      if (isNaN(unitCompare) || unitCompare < 0) unitCompare = 0;

      var volUnit = volumeUnitPrice(unitPrice, qty, priceWrap);
      var priceEl = priceWrap.querySelector('[data-lande-price-main]');
      var compareEl = priceWrap.querySelector('[data-lande-price-compare]');

      if (mode === 'first_order') {
        var foUnit = Math.floor(volUnit * 90 / 100);
        if (compareEl) {
          compareEl.textContent = formatMoney(unitPrice * qty, moneyFormat);
          compareEl.style.display = '';
        }
        if (priceEl) priceEl.textContent = formatMoney(foUnit * qty, moneyFormat);
        return;
      }

      if (mode === 'b2b') {
        var b2bUnit = Math.floor(volUnit * 70 / 100);
        if (priceEl) priceEl.textContent = formatMoney(b2bUnit * qty, moneyFormat);
        if (compareEl) {
          compareEl.textContent = formatMoney(unitPrice * qty, moneyFormat);
          compareEl.style.display = '';
        }
        return;
      }

      if (priceEl) priceEl.textContent = formatMoney(volUnit * qty, moneyFormat);
      if (compareEl) {
        if (unitCompare > unitPrice) {
          compareEl.textContent = formatMoney(unitCompare * qty, moneyFormat);
          compareEl.style.display = '';
        } else if (volUnit < unitPrice) {
          compareEl.textContent = formatMoney(unitPrice * qty, moneyFormat);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
    }

    function updateQuoteSummary(root) {
      if (!root) return;
      var modal = root.querySelector('[data-lande-quote-modal]');
      if (!modal) return;
      var moneyFormat = root.getAttribute('data-money-format') || '$1';

      var qty = getPdpQty(root);
      var variantSelect = root.querySelector('[data-lande-pdp-variant-select]');

      var variantLabel = '';
      var unitPriceCents = 0;
      if (variantSelect && variantSelect.options.length) {
        var activeOption = variantSelect.options[variantSelect.selectedIndex];
        if (activeOption) {
          variantLabel = activeOption.textContent.trim();
          unitPriceCents = parseInt(String(activeOption.getAttribute('data-price-cents') || '0'), 10);
          if (isNaN(unitPriceCents) || unitPriceCents < 0) unitPriceCents = 0;
        }
      } else {
        variantLabel = root.getAttribute('data-default-variant-label') || '';
        unitPriceCents = parseInt(String(root.getAttribute('data-default-variant-price') || '0'), 10);
        if (isNaN(unitPriceCents) || unitPriceCents < 0) unitPriceCents = 0;
      }

      var priceWrap = root.querySelector('[data-lande-pdp-price]');
      var quoteUnit = unitPriceCents;
      if (priceWrap) quoteUnit = volumeUnitPrice(unitPriceCents, qty, priceWrap);

      var qtyNode = modal.querySelector('[data-lande-quote-qty]');
      var variantNode = modal.querySelector('[data-lande-quote-variant]');
      var totalNode = modal.querySelector('[data-lande-quote-total]');
      var qtyHidden = modal.querySelector('[data-lande-quote-input-qty]');
      var variantHidden = modal.querySelector('[data-lande-quote-input-variant]');

      if (qtyNode) qtyNode.textContent = String(qty);
      if (variantNode) variantNode.textContent = variantLabel || '-';
      if (totalNode) totalNode.textContent = formatMoney(quoteUnit * qty, moneyFormat);
      if (qtyHidden) qtyHidden.value = String(qty);
      if (variantHidden) variantHidden.value = variantLabel || '';
    }

    function syncVariantUnitPrice(root, opt) {
      if (!root || !opt) return;
      var priceWrap = root.querySelector('[data-lande-pdp-price]');
      if (!priceWrap) return;
      var unitCents = parseInt(String(opt.getAttribute('data-price-cents') || '0'), 10);
      if (isNaN(unitCents) || unitCents < 0) unitCents = 0;
      priceWrap.setAttribute('data-unit-price', String(unitCents));
      priceWrap.setAttribute('data-unit-sale', String(Math.floor(unitCents * 90 / 100)));
      var compareCents = parseInt(String(opt.getAttribute('data-compare-cents') || '0'), 10);
      if (isNaN(compareCents) || compareCents < 0) compareCents = 0;
      if (compareCents > unitCents) {
        priceWrap.setAttribute('data-unit-compare', String(compareCents));
      } else {
        priceWrap.setAttribute('data-unit-compare', '');
      }
      if (priceWrap.getAttribute('data-price-mode') === 'b2b') {
        priceWrap.setAttribute('data-unit-sale', String(Math.floor(unitCents * 70 / 100)));
      }
      updateDisplayedPrice(root);
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-lande-pdp-tab]');
      if (!tab) return;
      var root = tab.closest('[data-lande-pdp-tabs]');
      if (!root) return;
      var key = tab.getAttribute('data-lande-pdp-tab');
      root.querySelectorAll('[data-lande-pdp-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      root.querySelectorAll('[data-lande-pdp-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-lande-pdp-panel') !== key;
      });
    });

    document.addEventListener('click', function (e) {
      var st = e.target.closest('[data-lande-scroll-top]');
      if (!st) return;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-lande-pdp-variant-select]');
      if (!sel) return;
      var root = sel.closest('.lande-pdp');
      if (!root) return;
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      syncVariantUnitPrice(root, opt);
      updateQuoteSummary(root);
    });

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-lande-quote-open]');
      if (openBtn) {
        var root = openBtn.closest('.lande-pdp');
        if (!root) return;
        var modal = root.querySelector('[data-lande-quote-modal]');
        if (!modal) return;
        updateQuoteSummary(root);
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var firstField = modal.querySelector('input[name="contact[name]"]');
        if (firstField) firstField.focus();
        return;
      }

      var closeBtn = e.target.closest('[data-lande-quote-close]');
      if (!closeBtn) return;
      var closeModal = closeBtn.closest('[data-lande-quote-modal]');
      if (!closeModal) return;
      closeModal.hidden = true;
      document.body.style.overflow = '';
    });

    document.addEventListener('input', function (e) {
      if (!e.target.matches('.lande-pdp__form input[name="quantity"]')) return;
      var root = e.target.closest('.lande-pdp');
      updateDisplayedPrice(root);
      updateQuoteSummary(root);
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('.lande-pdp__form input[name="quantity"]')) return;
      var root = e.target.closest('.lande-pdp');
      updateDisplayedPrice(root);
      updateQuoteSummary(root);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openedModal = document.querySelector('[data-lande-quote-modal]:not([hidden])');
      if (!openedModal) return;
      openedModal.hidden = true;
      document.body.style.overflow = '';
    });

    document.addEventListener('submit', function (e) {
      var quoteForm = e.target.closest('[data-lande-quote-form]');
      if (!quoteForm) return;
      e.preventDefault();
      var root = quoteForm.closest('.lande-pdp');

      var feedback = quoteForm.querySelector('[data-lande-quote-feedback]');
      if (feedback) {
        feedback.hidden = true;
        feedback.textContent = '';
      }

      var submitBtn = quoteForm.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/contact', {
        method: 'POST',
        body: new FormData(quoteForm),
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (res.status >= 500) throw new Error('quote_failed');
          return res.text().then(function (body) {
            if (res.status >= 400 && body && body.toLowerCase().indexOf('error') !== -1) {
              throw new Error('quote_failed');
            }
            return body;
          });
        })
        .then(function () {
          if (feedback) {
            feedback.hidden = false;
            feedback.textContent = root && root.getAttribute('data-quote-success-message')
              ? root.getAttribute('data-quote-success-message')
              : 'Success';
            feedback.style.color = '#0b7a33';
          }
          quoteForm.reset();
          setTimeout(function () {
            var modal = quoteForm.closest('[data-lande-quote-modal]');
            if (!modal) return;
            modal.hidden = true;
            document.body.style.overflow = '';
          }, 1400);
        })
        .catch(function () {
          if (feedback) {
            feedback.hidden = false;
            feedback.textContent = root && root.getAttribute('data-quote-error-message')
              ? root.getAttribute('data-quote-error-message')
              : 'Error';
            feedback.style.color = '#b42318';
          }
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
          updateQuoteSummary(root);
        });
    });
    document.querySelectorAll('[data-pdp-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-pdp-track]');
      var slides = carousel.querySelectorAll('[data-pdp-slide]');
      var dots = carousel.querySelectorAll('[data-pdp-dot]');
      var prev = carousel.querySelector('[data-pdp-prev]');
      var next = carousel.querySelector('[data-pdp-next]');
      if (!track || slides.length < 2) return;

      var index = 0;
      var startX = 0;
      var deltaX = 0;
      var dragging = false;

      function goTo(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        dots.forEach(function (dot, i) {
          if (i === index) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-pdp-dot'), 10) || 0);
        });
      });

      carousel.addEventListener('touchstart', function (e) {
        if (!e.changedTouches || !e.changedTouches[0]) return;
        dragging = true;
        startX = e.changedTouches[0].clientX;
        deltaX = 0;
        track.style.transition = 'none';
      }, { passive: true });

      carousel.addEventListener('touchmove', function (e) {
        if (!dragging || !e.changedTouches || !e.changedTouches[0]) return;
        deltaX = e.changedTouches[0].clientX - startX;
        var percent = (deltaX / carousel.offsetWidth) * 100;
        track.style.transform = 'translateX(' + ((-index * 100) + percent) + '%)';
      }, { passive: true });

      carousel.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        if (Math.abs(deltaX) > 40) {
          goTo(deltaX < 0 ? index + 1 : index - 1);
        } else {
          goTo(index);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
